import Tab from "components/common/Tab/tab";
import Tabs from "components/common/Tab/tabs";
import { useParams } from "next/navigation";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import useIsMobile from "states/deviceState";
import { DETAIL_AUTO_SCROLL, RISK } from "utils/constant/ETC";
import { AI, ASSETINFO, PORTFOLIO } from "utils/constant/STATUS";
import { routeToStockDetailPage } from "utils/routing";
import { useTabTracking } from "lib/analytics/react/hooks";
function SDTabs({
  setType,
  type,
  detailData,
  isNullDetailInfo,
  t,
  isValidScoreStock,
}: {
  setType: any;
  type: string;
  detailData: any;
  isNullDetailInfo: boolean;
  t: any;
  isValidScoreStock: boolean;
}) {
  const router = useRouter();
  const { ticker } = useParams();
  const onChangingRef = useRef(false);

  const isMobile = useIsMobile();
  const { trackClick } = useTabTracking("stock_tab_click", ["chart", "info"]);
  return (
    <div
      className={`flex space-x-5  bg-white sticky z-[4] ${
        isMobile ? "top-[64px]" : "top-[120px]"
      }`}
    >
      <Tabs type={"line"}>
        <Tab
          title={t("chart")}
          onClick={() => {
            trackClick("chart");
            setType(AI);
            window.dataLayer.push({
              event: "ClickDetailTabDiag",
            });

            routeToStockDetailPage(router, ticker as string, "replace", {
              shallow: true,
              scroll: false,
            });

            setTimeout(() => {
              window.scrollTo({
                top: DETAIL_AUTO_SCROLL,
                behavior: "smooth",
              });
            }, 10);
          }}
          isActive={type === AI}
          type={"line"}
        />

        {!isNullDetailInfo && (
          <Tab
            title={t("assetInfo")}
            onClick={() => {
              trackClick("info");
              setType(ASSETINFO);
              window.dataLayer.push({
                event: "ClickDetailTabInfo",
              });

              routeToStockDetailPage(router, ticker as string, "replace", {
                shallow: true,
                scroll: false,
              });
            }}
            isActive={type === ASSETINFO}
            type={"line"}
          />
        )}
      </Tabs>
    </div>
  );
}

export default SDTabs;
